// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_3R7Zv","indicator":"index_indicator_CyZDa","indicator-item":"index_indicator-item_2o51M","active":"index_active_TRr2b"};